import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import moment from 'moment'
import { BasicSelect,ModelSelect} from 'vue-search-select';
import Paginate from 'vuejs-paginate'

export default {
  name: 'GroupConnectionMapping',
  components: {
    BasicSelect,
    ModelSelect,
    Paginate,
    VueElementLoading,
    Multiselect
  },
  data: function() {
    return {
      isDisabled:false,
      isLoadingtable:false,
      listHubZoneData:[],
      cityList: [],
      groupList: [],
      connectionList: [],
      parentHubList: [],

      fetchedHubs: [],
      allBagTypes: [],
      bagTypenew: [],
      tempitems: [],
      bagTypeFound: true,

      destinationcityid: '',
      destinationcityname: '',
      origincityid: '',
      originHubName: '',
      groupType: '',
      connectionType: '',
      connectionid: '',
      connectionName: '',
      parentHub: '',
      parentHubName: '',
      allowBagpattern: false,
      isActive: true,
      bagType: [],
      isLoading: false,
      isLoadingflt: false,
      useremail: '',

      citySearch: '',
      groupSearch: '',
      searchGroupList: [],
      searchparentHubList: [],
      searchparentHub: '',
      searchparentHubname: '',
      mapHubId: '',
      HubID:'',
      mapHubname: '',
      noConnection: false,
      bagTypeSelected: true,

      showHubsModal: false,
      hubStatusModal: false,
      changestatusHub: '',
      groupId: '',
      destinationHubId: '',

      groupTypeList: [],

      connectionTypeList: [{
          value: "LC",
          text: "Local Connection"
        },
        {
          value: "LHC",
          text: "LineHaul Connection"
        },
        {
          value: "Biker",
          text: "Biker"
        }
      ],

      destinationcityObjData: {
        value: "",
        text: ""
      },
      origincityObjData: {
        value: "",
        text: ""
      },
      parentHubObjData: {
        value: "",
        text: ""
      },
      groupTypeObjData: {
        value: "",
        text: ""
      },
      connectionTypeObjData: {
        value: "",
        text: ""
      },
      connectionObjData: {
        value: "",
        text: "",
        route: ""
      },
      citySearchObjData: {
        value: "",
        text: ""
      },
      groupSearchObjData: {
        value: "",
        text: ""
      },
      searchparentHubListObjData: {
        value: "",
        text: "",
      },
      maphubObjData: {
        value: "",
        text: "",
        hubcode: ""
      },
      resultCount: 0,
      pageno: 0,
      pagecount: 0,
      totalRows: 0,
      limit: 10,
      searchFlag: false,
      grpConnMapList: [],
      connectiongroupmappingid: '',
      groupConnectionAllocatedDestId: '',
      allocateHubmodal: false,
      updateparentHubmodal: false,
      groupConnectionStatusModal: false,
      changestatus: '',
      originHubIdStatus: '',
      mappedHUbsList: [],
      mappedHubCount: 0,
      connectionGroupMappingIdStatus: '',
      actualRoute: '',
      selectedbagtype: '',
      totalmappedhubs: 0,
      connectionDestList: [],
      HubArr: [],
      destData: [],
      zoneLoading:'',
      checkAllHub:false,
      connDestLoading:false,
      hubzoneid :'',
      addmodalShow:false,
      fetchedconnectionid:'',
      savedBagType:[],
      modelArr:[],
      allHubData:[],
      checked:[],
      clickedMB:false
    }
  },

  created: function() {},
  computed: {},

  mounted() {

    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext)
    this.useremail = userdetail[0].email;

    this.getCityList();
    this.getAllHubs();
    this.getHubZoneData();
  },
  methods: {
    selectedDestination(cityData) {
      this.groupType ='',
      this.origincityid ='',
      this.connectionType ='',
      this.connectionid ='',
      this.parentHub ='',
      this.groupTypeObjData = {};
      this.origincityObjData = {};
      this.connectionTypeObjData = {};
      this.connectionObjData = {};
      this.parentHubObjData = {};
      this.destinationcityObjData = cityData
      this.destinationcityid = cityData.value
      this.destinationcityname = cityData.text
      if (this.destinationcityid != "") {
        //this.getDestinationHubMaster();
        this.getCitywiseGroups();
      }
      this.resetDes();
    },
    selectedOrigin(cityData) {
      //console.log(cityData);
      this.origincityObjData = cityData
      this.origincityid = cityData.value;
      var splitVal = cityData.text.split(" ");
      this.originHubName = splitVal[0];
      this.actualRoute = ""
      this.getConnection();
      if (this.destinationcityid != "" && this.origincityid != "") {
        this.getDestinationHubMaster();
      }
      this.resetDes();
    },
    selectedHub(hubData) {
      //console.log(cityData);
      this.parentHubObjData = hubData
      this.parentHub = hubData.value
      var splitVal = hubData.text.split(" ");
      this.parentHubName = splitVal[0];
      this.actualRoute = ""
      this.resetDes();
    },
    selectedGroupType(groupTypeData) {
      this.groupTypeObjData = groupTypeData;
      this.groupType = groupTypeData.value;
      this.bagTypenew = [];
      this.getBagtypes();
    },
    selectedConnectionType(connTypeData) {
      //console.log(cityData);
      this.connectionTypeObjData = connTypeData
      this.connectionType = connTypeData.value
      this.actualRoute = ""
      this.getConnection();
      this.resetDes();
    },
    selectedConnection(connData) {
      //console.log(cityData);
      this.connectionObjData = connData
      this.connectionid = connData.value
      this.connectionName = connData.text
      this.actualRoute = connData.route
      this.resetDes();
    },
    selectedCitySearch(cityData) {
      //console.log(cityData);
      this.citySearchObjData = cityData
      this.citySearch = cityData.value
      // this.searchGroupList=[]
      this.groupSearchObjData = {
        value: "",
        text: ""
      }
      this.groupSearch = ''
      this.getCitywiseGroupsSearch();
    },
    selectedgroupSearch(groupData) {
      //console.log(cityData);
      this.groupSearchObjData = groupData
      this.groupSearch = groupData.value
    },
    selectedsearchparentHub(hubData) {
      this.searchparentHubListObjData = hubData
      this.searchparentHub = hubData.value;
      var temp = hubData.text.split('(');
      var temp1 = temp[0].trim();
      this.searchparentHubname = temp1;
    },
    selectedHubName(hubData) {
      this.maphubObjData = hubData
      this.mapHubId = hubData.value
      var splitVal = hubData.text.split("-");
      this.mapHubname = splitVal[1];
      //changed
    },

    //to get City list
    getCityList() {
      this.isLoading = true;
      //var userToken = window.localStorage.getItem('userToken')
      //var myStr = userToken.replace(/"/g, '');
      var i = 0;
      this.resultCount = 0;
      this.input = ({})
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'allcity/get',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.isLoading = false;
          var cityList = result.data.ResponseData
          for (i = 0; i < cityList.length; i++) {
            this.cityList.push({
              value: cityList[i].cityid,
              text: cityList[i].cityname
            })
          }
        }, error => {
          console.error(error)
        })
    },

    getDestinationHubMaster() {
      this.parentHubObjData = {};
      //var userToken = window.localStorage.getItem('userToken')
      //var myStr = userToken.replace(/"/g, '');
      var i = 0;
      this.parentHubList = [];
      this.resultCount = 0;
      this.input = ({
        CityId: this.destinationcityid,
      })
      this.isLoading = true;
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/citywise',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.isLoading = false;
          // this.parentHubList = result.data.data
          var parentHubList = result.data.ResponseData
          for (i = 0; i < parentHubList.length; i++) {
            if (this.origincityid != parentHubList[i].HubID) {
              this.parentHubList.push({
                value: parentHubList[i].HubID,
                text: parentHubList[i].HubName + ' (' + parentHubList[i].HubID + ')'
              })
            } else {
              //alert("found");
            }

          }
        }, error => {
          this.isLoading = false;
          console.error(error)
        })
    },

    getCitywiseGroups() {
      if (this.destinationcityid == undefined || this.destinationcityid == '' || this.destinationcityid == null) {
        return false;
      }
      this.groupTypeObjData = {};
      this.groupTypeList = [];
      var i = 0;
      this.input = ({})
      this.isLoadingflt = true;
      axios({
          method: 'GET',
          // legacy backup: getCityWiseGroups
          // 'url': apiUrl.api_url_hubops + 'getCityWiseGroups?cityId=' + this.destinationcityid + '&isActive=true',
          'url': apiUrl.api_url_hubops + 'groups?cityId=' + this.destinationcityid + '&isActive=true',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.isLoadingflt = false;
          if (result.data.ResultCode == 100) {
            var groupTypeList = result.data.ResponseData
            for (i = 0; i < groupTypeList.length; i++) {
              this.groupTypeList.push({
                value: groupTypeList[i].groupid,
                text: groupTypeList[i].groupname + ' - ' + groupTypeList[i].routemode + ' - ' + groupTypeList[i].groupno
              })
            }
          } else {
            this.groupTypeList = [];
          }
        }, error => {
          this.isLoadingflt = false;
          console.error(error)
        })
    },

    getAllHubs() {
      this.isLoading = true;
      this.hubLoading = 'Loading Hub...'
      var i = 0;
      this.input = ({})
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'expose/hubservicecenter/dropdwon/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.isLoading = false;
          this.hubLoading = ''
          var fetchedHubs = result.data.ResponseData
          for (i = 0; i < fetchedHubs.length; i++) {
            this.fetchedHubs.push({
              value: fetchedHubs[i].HubID,
              text: fetchedHubs[i].HubCode + ' - ' + fetchedHubs[i].HubName + ' (' + fetchedHubs[i].HubID + ')',
              hubcode: fetchedHubs[i].HubCode
            })
          }
        }, error => {
          console.error(error)
        })

    },

    getBagtypes() {
      if (this.groupType == null || this.groupType == undefined || this.groupType == '') {
        return false;
      }
      this.isLoading = true;
      this.bagTypeFound = true;
      var i = 0;
      this.input = ({})
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + 'getBagTypesByGroupId?groupId=' + this.groupType,
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.isLoading = false;
          this.allBagTypes = [];
          var allBagTypes = result.data.ResponseData

          if (allBagTypes.length != 0) {
            for (i = 0; i < allBagTypes.length; i++) {
              this.allBagTypes.push({
                id: i,
                text: allBagTypes[i].bagtype
              })
            }
          } else {
            this.bagTypeFound = false;
          }
        }, error => {
          console.error(error)
        })

    },

    getConnection() {
      if (this.connectionType != "" && this.origincityid != "") {
        this.connectionList = [];
        this.connectionObjData = {};
        this.connectionid = '';
        this.$validator.reset();
        if (this.connectionType == "LC") {
          var gptype = 1;
        } else if (this.connectionType == "Biker") {
          var gptype = 6;
        } else {
          var gptype = 3;
        }
        var i = 0;
        if (this.connectionType == '' || this.connectionType == undefined) {
          return false
        }
        this.isLoading = true;
        this.input = ({
          type: gptype,
          source: this.origincityid
        })
        axios({
            'method': 'POST',
            'url': apiUrl.api_url_hubops + 'getroutemaster',
            'data': this.input,
            'headers': {
              'authorization': 'authkey xB84JJ89Hd25'
            }
          })
          .then(result => {
            this.isLoading = false;
            if (result.data.ResultCode == 100) {
              var connectionList = result.data.ResponseData
              this.noConnection = false;
              for (i = 0; i < connectionList.length; i++) {
                this.connectionList.push({
                  value: connectionList[i].ConnectionID,
                  text: connectionList[i].ConnectionName,
                  route: connectionList[i].FullConnectionName,
                })
              }
            } else {
              this.noConnection = true;
            }
          }, error => {
            this.isLoading = false;
            this.noConnection = false;
            console.error(error)
          })
      } else {
        return false;
      }
    },

    saveGroupMapping() {
      if (this.destinationcityid == "" || this.groupType == "" && this.parentHub == "" && this.origincityid == "" || this.connectionid == "") {
        return false;
      } else {
        this.isLoading = true;

        this.input = ({
          cityId: this.destinationcityid,
          cityName: this.destinationcityname,
          groupId: this.groupType,
          originHubId: this.origincityid,
          connectionType: this.connectionType,
          parentHubId: this.parentHub,
          originHubName: this.originHubName,
          connectionName: this.connectionName,
          parentHubName: this.parentHubName,
          connectionId: this.connectionid,
          isBaggingPattern: this.allowBagpattern,
          bagTypes: this.bagType.toString(),
          createdBy: this.useremail,
        })
        axios({
            method: 'POST',
            'url': apiUrl.api_url_hubops + 'connectionGroupMapping',
            'data': this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
            }
          })
          .then((result) => {
            this.isLoading = false;
            if (result.data.ResultCode == 500) {
              this.$alertify.error(result.data.ReturnMessage)
              //this.$alert(result.data.ReturnMessage, "", "error");
            }
            if (result.data.ResultCode == 101) {
              this.$alert(result.data.ReturnMessage, "", "error");
              this.mapMultipleHubsToConnection();
            }
            if (result.data.ResultCode == 100) {
              this.$alertify.success(result.data.ReturnMessage, "", "error");
              this.mapMultipleHubsToConnection();
            }
          })
          .catch((httpException) => {
            console.error('exception is:::::::::', httpException)
          })
      }

    },
    getGroupConnection(){
      this.pageno = 0;
      this.getGroupConnectionList();
    },

    getGroupConnectionList() {
      if (this.groupSearch == null || this.groupSearch == undefined || this.groupSearch == '') {
        return false;
      } else {
        this.isLoadingflt = true;
        this.searchFlag = true;
        this.input = ({})
        this.totalRows = 0;
        axios({
            method: 'GET',
            // HUB-8335: replaces fetchHubDetailsByGroupId (paginated full rows + TotalCount)
            'url': apiUrl.api_url_hubops + 'groups/' + this.groupSearch + '/connection-mappings?fields=full&offset=' + this.pageno + '&limit=' + this.limit + '&includeTotalCount=true',
            'data': this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
            }
          })
          .then((result) => {
              this.isLoadingflt = false;
            if (result.data.ResultCode == 500) {
              //this.$alertify.error(result.data.ReturnMessage)
              this.grpConnMapList = []
              this.resultCount = 0
              this.totalRows = 0
              this.$alert(result.data.ReturnMessage, "", "error");
            }
            if (result.data.ResultCode == 101) {
              //this.$alertify.error(result.data.ReturnMessage)
              this.grpConnMapList = []
              this.resultCount = 0
              this.totalRows = 0
              this.$alert(result.data.ReturnMessage, "", "error");
            }
            if (result.data.ResultCode == 100) {
              this.getDestinationHubMasterSearch();
              this.grpConnMapList = result.data.ResponseData;
              //console.log(this.grpConnMapList);
              this.resultCount = result.data.ResponseData.length
              this.totalRows = result.data.TotalCount
              if (this.totalRows < this.limit) {
                this.pagecount = 1
              } else {
                this.pagecount = Math.ceil(this.totalRows / this.limit)
              }
            }

          })
          .catch((httpException) => {
            this.isLoadingflt = false;
            console.error('exception is:::::::::', httpException)
          })
      }
    },

    getCitywiseGroupsSearch() {
      if (this.citySearch == null || this.citySearch == undefined || this.citySearch == '') {
        return false;
      }
      // this.groupTypeObjData = {};
      this.searchGroupList = [];
      var i = 0;
      this.isLoadingflt = true;
      this.input = ({})
      axios({
          method: 'GET',
          // legacy backup: getCityWiseGroups
          // 'url': apiUrl.api_url_hubops + 'getCityWiseGroups?cityId=' + this.citySearch + '&isActive=true',
          'url': apiUrl.api_url_hubops + 'groups?cityId=' + this.citySearch + '&isActive=true',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.isLoadingflt = false;
          var searchGroupList = result.data.ResponseData
          //console.log(searchGroupList);
          for (i = 0; i < searchGroupList.length; i++) {
            this.searchGroupList.push({
              value: searchGroupList[i].groupid,
              text: searchGroupList[i].groupname + ' - ' + searchGroupList[i].routemode + ' - ' + searchGroupList[i].groupno
            })
          }
        }, error => {
          this.isLoadingflt = false;
          console.error(error)
        })
    },

    getDestinationHubMasterSearch() {

      var i = 0;
      this.searchparentHubList = [];
      this.input = ({
        CityId: this.citySearch,
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/citywise',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          var searchparentHubList = result.data.ResponseData
          for (i = 0; i < searchparentHubList.length; i++) {
            this.searchparentHubList.push({
              value: searchparentHubList[i].HubID,
              text: searchparentHubList[i].HubName + ' (' + searchparentHubList[i].HubID + ')',
            })
          }
        }, error => {
          console.error(error)
        })
    },

    getParentHubRowData(data) {
      this.connectiongroupmappingid = data.connectiongroupmappingid;
      this.updateparentHubmodal = true;
    },
    closeUpdateParentHub() {
      this.updateparentHubmodal = false;
    },
    getStatusRowData(data) {
      this.originHubIdStatus = data.originhubid
      if (data.isactive == true) {
        this.changestatus = 'De-Activate'
      } else {
        this.changestatus = 'Activate'
      }
      //alert(this.changestatus);
      this.groupConnectionStatusModal = true;
      this.connectiongroupmappingid = data.connectiongroupmappingid;
    },
    changeGroupConnectionStatus() {
      this.isLoadingflt = true;
      if (this.changestatus == 'De-Activate') {
        var newStatus = false;
      } else {
        var newStatus = true;
      }
      this.input = ({
        connectiongroupmappingid: this.connectiongroupmappingid,
        groupId: this.groupSearch,
        cityId: this.citySearch,
        originHubId: this.originHubIdStatus,
        isActive: newStatus,
        createdBy: this.useremail,
      })
      axios({
          method: 'PUT',
          'url': apiUrl.api_url_hubops + 'deAllocateConnectionGroupMapping',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then((result) => {
          this.getGroupConnectionList();
          this.isLoadingflt = false;
          if (result.data.ResultCode == 500) {
            //this.$alertify.error(result.data.ReturnMessage)
            this.$alert(result.data.ReturnMessage, "", "error");
          }
          if (result.data.ResultCode == 101) {
            //this.$alertify.error(result.data.ReturnMessage)
            this.$alert(result.data.ReturnMessage, "", "error");
          }
          if (result.data.ResultCode == 100) {
            //this.$alertify.success('Template Status Changed Successfully')
            this.$alert('Template Status Changed Successfully', "", "success");
          }
          this.groupConnectionStatusModal = false;
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },

    getHubMappedListData(data) {
      this.isLoadingflt = true;
      this.input = ({})
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + 'getConnectionGroupLocationsByConnectionMappingId?connectionGroupMappingId=' + data.connectiongroupmappingid,
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.isLoadingflt = false;
          if (result.data.ResultCode == 500) {
            //this.$alertify.error(result.data.ReturnMessage)
            this.$alert(result.data.ReturnMessage, "", "error");
          }
          if (result.data.ResultCode == 101) {
            //this.$alertify.error(result.data.ReturnMessage);
            this.$alert('Group Template Not Found For The Selected City', "", "error");
            this.resultCount = 0;
            this.mappedHUbsList = [];
          }
          if (result.data.ResultCode == 100) {
            this.mappedHUbsList = result.data.ResponseData;
            this.mappedHubCount = result.data.ResponseData.length;
            this.showHubsModal = true;
          }
        }, error => {
          console.error(error)
        })
    },
    closeStatusGroupModal() {
      this.groupConnectionStatusModal = false;
    },

    // openHubMapModal(data) {
    //   //console.log(data);
    //   this.connectiongroupmappingid = data.connectiongroupmappingid;
    //   this.maphubObjData = {
    //     value: '',
    //     text: '',
    //     hubcode: ''
    //   }
    //   this.mapHubId = ''
    //   this.allocateHubmodal = true;
    // },
    closeAllocateHubModal() {
      this.allocateHubmodal = false;
    },
    updateparentHub() {
      if (this.searchparentHub != "") {
        this.input = ({
          connectiongroupmappingid: this.connectiongroupmappingid,
          parentHub: this.searchparentHub,
          parentHubName: this.searchparentHubname,
          createdBy: this.useremail,
        })
        this.isLoadingtable = true;
        axios({
            method: 'PUT',
            'url': apiUrl.api_url_hubops + 'updateParentHub	',
            'data': this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
            }
          })
          .then(result => {
            this.isLoadingtable = false;
            if (result.data.ResultCode == 500) {
              //this.$alertify.error(result.data.ReturnMessage)
              this.$alert(result.data.ReturnMessage, "", "error");
            }
            if (result.data.ResultCode == 101) {
              //this.$alertify.error(result.data.ReturnMessage)
              this.$alert(result.data.ReturnMessage, "", "error");
            }
            if (result.data.ResultCode == 100) {
              //this.$alertify.success('Parent HUb Updated Successfully')
              this.$alert('Parent HUb Updated Successfully', "", "success");
            }
            this.updateparentHubmodal = false;
            this.searchparentHub = '';
            this.searchparentHubListObjData = {};
            this.hubListObjData = {};
            if (this.citySearch != '' && this.groupSearch != "") {
              this.getGroupConnectionList();
            }
          }, error => {
            this.isLoadingtable = false;
            console.error(error)
          })
      } else {
        //this.$alertify.error("Please Select Any HUb");
        this.$alert("Please Select Any HUb", "", "error");
        return false;
      }
    },

    saveMapHubWithGroupConnection() {
      if (this.mapHubId != "") {
        //this.isLoading = true;
        this.input = ({
          connectionGroupMappingId: this.connectiongroupmappingid,
          groupId: this.groupSearch,
          destinationHubCode: this.maphubObjData.hubcode,
          destinationHubId: this.mapHubId,
          destinationHubName: this.mapHubname,
          createdBy: this.useremail,
        })
        axios({
            method: 'POST',
            'url': apiUrl.api_url_hubops + 'connectionGroupLocations',
            'data': this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
            }
          })
          .then(result => {
            //this.isLoading = false;
            if (result.data.ResultCode == 500) {
              //this.$alertify.error(result.data.ReturnMessage)
              this.$alert(result.data.ReturnMessage, "", "error");
            }
            if (result.data.ResultCode == 101) {
              //this.$alertify.error(result.data.ReturnMessage)
              this.$alert(result.data.ReturnMessage, "", "error");
            }
            if (result.data.ResultCode == 100) {
              //this.$alertify.success('Hub Mapped To This Group Connection')
              this.$alert('Hub Mapped To This Group Connection', "", "success");
            }
            this.allocateHubmodal = false;
            this.maphubObjData = {
              value: '',
              text: '',
              hubcode: ''
            };
          }, error => {
            console.error(error)
          })
      } else {
        //this.$alertify.error("Please Select Any HUb");
        this.$alert("Please Select Any HUb", "", "error");
        return false;
      }
    },

    getStatusHublistData(data) {
      this.hubStatusModal = true;
      this.showHubsModal = false;
      this.connectionGroupMappingIdStatus = data.connectiongroupmappingid
      this.groupId = data.groupid
      this.destinationHubId = data.destinationhubid

      if (data.isactive == true) {
        this.changestatusHub = 'De-Activate'
      } else {
        this.changestatusHub = 'Activate'
      }
    },

    changeMappedHubStatus() {
      this.isLoading = true;
      if (this.changestatusHub == 'De-Activate') {
        var newStatus = false;
      } else {
        var newStatus = true;
      }
      this.input = ({
        connectionGroupMappingId: this.connectionGroupMappingIdStatus,
        groupId: this.groupId,
        destinationHubId: this.destinationHubId,
        isActive: newStatus,
        createdBy: this.useremail
      })
      axios({
          method: 'PUT',
          'url': apiUrl.api_url_hubops + 'deAllocateconnectionGroupLocations',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then((result) => {
          this.isLoading = false;
          if (result.data.ResultCode == 500) {
            //this.$alertify.error(result.data.ReturnMessage)
            this.$alert(result.data.ReturnMessage, "", "error");
          }
          if (result.data.ResultCode == 101) {
            //this.$alertify.error(result.data.ReturnMessage)
            this.$alert(result.data.ReturnMessage, "", "error");
          }
          if (result.data.ResultCode == 100) {
            //this.$alertify.success('Hub Status Changed Successfully')
            this.$alert('Hub Status Changed Successfully', "", "success");
          }
          this.hubStatusModal = false;
          this.showHubsModal = false;
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },

    closeMapHubWithGroup() {
        this.allocateHubmodal = false;
        this.hubListObjData = {
          value: "",
          text: ""
        }
      },

    closeStatusHubModal() {
      this.hubStatusModal = false;
    },
    closeHubsModal() {
      this.showHubsModal = false;
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
    },
    //to reset search form
    resetForm() {
      this.isDisabled = false;
      this.destinationcityid = '';
      this.origincityid = '';
      this.groupType = '';
      this.connectionType = '';
      this.connectionid = '';
      this.parentHub = '';
      this.bagType = [];
      this.allowBagpattern = false;
      this.destinationcityObjData = {};
      this.groupTypeObjData = {};
      this.origincityObjData = {};
      this.connectionTypeObjData = {};
      this.connectionObjData = {};
      this.parentHubObjData = {};
      this.noConnection = false;
      this.bagTypeSelected = true;
      this.addmodalShow= false;
      this.bagTypenew = [];
      this.zoneLoading= '';
      this.hubzoneid= '';
      this.selectedbagtype = '';
      this.actualRoute = '';
      this.savedBagType = [];
      this.$validator.reset();
      this.resetDes();
    },

    //for multiple dropdown's selected option
    selectedBagType(bagData) {
      // console.log(bagData);
      this.selectedbagtype = bagData.text
      var item = {
        id: bagData.id,
        title: bagData.text
      }
      if (this.bagTypenew.hasOwnProperty(bagData.id) == true) {
        //this.$alertify.error("Bagtype Already Selected")
        this.$alert("Bagtype Already Selected", "", "error");
      } else {
        this.bagTypeSelected = true;
        this.bagTypenew.push(item);
        this.tempitems.push(bagData.id)
      }
      this.bagType = Array.prototype.map.call(this.bagTypenew, function(item) {
        return item.title;
      }).join(",");

    },
    removeBagType(id, index) {
      this.tempitems.splice(this.tempitems.indexOf(id), 1);
      this.bagTypenew.splice(index, 1);
      this.bagType = Array.prototype.map.call(this.bagTypenew, function(item) {
        return item.title;
      }).join(",");
      if (this.bagTypenew.length == 0) {
        this.bagTypeSelected = false;
      }

    },


    //validate all form fields on onsubmit()
    onSubmit: function() {
      this.$validator.validateAll()
      .then((result) => {
        if (!result) {
          this.clickedMB=false;
          return false;
        }else {
          this.hubzoneid = '';
          this.resetDes();
          this.getDestinationsByConnection();
        }
      }).catch(() => {
      console.log('errors exist')
      });
    },

    ///////////////////////// Rto file data //////////////////////////////////////////////////////////////////////

    getDestinationsByConnection() {

      this.connDestLoading    = true;
      this.destData           = [];
      this.HubArr             = [];
      this.totalmappedhubs    = 0;
      this.checkAllHub        = false;
      this.fetchedconnectionid = '';
      this.savedBagType = [];
      this.isDisabled = false;
      this.clickedMB=true;

      axios({
            method: 'GET',
            'url': apiUrl.api_url_hubops + 'fetchGroupConnectionMapping?cityId=' + this.destinationcityid + '&connectionId=' + this.connectionid + '&originHubId=' + this.origincityid + '&groupId=' + this.groupType +(this.hubzoneid ? "&hubzoneid="+this.hubzoneid : ''),
            headers: {
              'Authorization': "authkey xB84JJ89Hd25"
            }
          })
            .then(result => {
        if (result.data.ResultCode == 100) {
          let j=0; let list=[]; let dlist=[];
          let hData = result.data.ResponseData;
          for (var i = 0; i < hData.length; i++) {
            if(j<4){
              list.push({
                hubId:hData[i].HubID,
                hubName:hData[i].HubName,
                hubCode:hData[i].HubCode
              });
            }else{
              dlist.push(list);
              list=[]
              list.push({
                hubId:hData[i].HubID,
                hubName:hData[i].HubName,
                hubCode:hData[i].HubCode
              });
              j=0;
            }
            j++;

            if(hData[i].isHubSelected==true){
              (this.HubArr.indexOf(hData[i].HubID) === -1) ? this.HubArr.push(hData[i].HubID):'';
              this.checked[hData[i].HubID] = true;
            }

            this.destData.push({
              hubId:hData[i].HubID,
              hubName:hData[i].HubName,
              hubCode:hData[i].HubCode
            });

            const allH = this.allHubData.some(el => el.hubId === hData[i].HubID);
            if (!allH) {
              this.allHubData.push({
                hubId:hData[i].HubID,
                hubName:hData[i].HubName,
                hubCode:hData[i].HubCode
              });
            }
          }

          this.modelArr = (this.modelArr.length>0) ? this.modelArr : this.HubArr;

          dlist.push(list);
          this.connectionDestList = dlist;
          this.totalmappedhubs  = result.data.AllocatedHubCount;
          if(result.data.BagType && result.data.BagType.length>0){
            this.savedBagType  = result.data.BagType;
            this.isDisabled = true;
          }
          this.fetchedconnectionid  = result.data.ConnectionIDs;
          this.resultgroupid  = result.data.GroupId;

          if(this.HubArr.length === this.destData.length) this.checkAllHub = true;
        }else{
          this.$alertify.error(result.data.ReturnMessage, "", "error");
        }
        this.connDestLoading=false;
      }, error => {
        console.log(error);
          this.connDestLoading=false;
        })
   	},

    checkHub() {
      if(typeof InstallTrigger !== 'undefined' == true){ this.checkAllHub = !this.checkAllHub; }
      this.HubArr = [];

      let nArr = [...new Set(this.destData.map(a => a.hubId))];

      if (this.checkAllHub) {

        for (var i = 0; i < this.destData.length; i++) {
          this.checked[this.destData[i].hubId]=true;
        }

        this.HubArr   = nArr;
        let arr = [...this.modelArr, ...nArr];
        this.modelArr = [...new Set(arr)];
      }else{

        for (var i = 0; i < this.destData.length; i++) {
          this.checked[this.destData[i].hubId]=false;
        }

        this.modelArr = this.modelArr.filter(val => !nArr.includes(val));
      }
    },

     updateCheckDest(event){
       this.checked[event.target.id] = event.target.checked;

       if(event.target.checked==false){
        this.modelArr = this.modelArr.filter(el => el != event.target.id)

       }else{
        this.modelArr.indexOf(event.target.id) === -1 ? this.modelArr.push(parseInt(event.target.id)):'';
       }

       this.checkAllHub = (this.destData.length === this.modelArr.length) ? true : false;
     },

    mapMultipleHubsToConnection() {
     this.connDestLoading = true;

     let nArr = this.allHubData.filter((elem) => this.modelArr.find((el) => elem.hubId == el));

     this.input = {
       connectionGroupMappingId: this.fetchedconnectionid,
       cityId: this.destinationcityid,
       cityName: this.destinationcityname,
       groupId: this.groupType,
       originHubId: this.origincityid,
       connectionType: this.connectionType,
       parentHubId: this.parentHub,
       originHubName: this.originHubName,
       connectionName: this.connectionName,
       parentHubName: this.parentHubName,
       connectionId: this.connectionid,
       isBaggingPattern: this.allowBagpattern,
       bagTypes: (this.savedBagType && this.savedBagType.length>0) ? this.savedBagType.join(",") : this.bagType,
       hubIdAndHubName: nArr,
       createdby: this.useremail
     }
     axios({
         method: 'POST',
         'url': apiUrl.api_url_hubops + "groupConnectionMappingAndAllocateLocationsToGroup_V1",
         'data': this.input,
         headers: {
           'Authorization': "authkey xB84JJ89Hd25"
         }
       })
       .then(result => {
         if (result.data.ResultCode == 100) {
           this.$alert(result.data.ReturnMessage, "", "success");
           this.hubzoneid = '';
           //this.getDestinationsByConnection();
           this.resetForm();
         } else {
           this.$alert(result.data.ReturnMessage, "", "error");
         }
         this.connDestLoading = false;
       }, error => {
         this.connDestLoading = false;
         console.error(error)
       })
    },

    takeAction() {
     this.mapMultipleHubsToConnection();
    },
    onSubmitHub: function(elem) {
     this.$validator.validateAll().then(async (result) => {
       if (result) {
         if (this.savedBagType.length<=0 && this.bagType.length <= 0) {
           this.$alertify.error('Bag type should not be empty'); return false;
         }
         else{
           this.addmodalShow = true
         }
       }else{
         console.log('save error'); return false;
       }
     }).catch(() => {});
   },

    //to get pagination
    getPaginationData(pageNum) {
      this.pageno = (pageNum - 1)
      this.getGroupConnectionList()
    },


   closeStatusModal() {
        this.addmodalShow = false
      },

    onSubmitFlt: function(Tab) {
      this.$validator.validateAll('Tab').then(() => {
        if (!result) {
          return false;
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },

    getHubZoneData() {

      this.zoneLoading = 'Loading Zone...';
      this.input = ({})
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubzone/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            let listHubZoneData = result.data.ResponseData;
            for (let i = 0; i < listHubZoneData.length; i++) {
              this.listHubZoneData.push({
                value: listHubZoneData[i].hubzoneid,
                text: listHubZoneData[i].hubzonename
              })
            }
          }
          this.zoneLoading = '';
        }, error => {
          this.zoneLoading = '';
          console.error(error);
        })
    },

    SelectZone() {
       this.getDestinationsByConnection();
    },

    resetDes(){
      this.HubArr= [];
      this.destData= [];
      this.allHubData= [];
      this.modelArr= [];
      this.checked= [];
      this.connectionDestList= [];
      this.connDestLoading = false;
      this.checkAllHub= false;
      this.totalmappedhubs= 0;
      this.clickedMB=false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/group/GroupConnectionMappingNew/GroupConnectionMappingNew.js